import { useEffect, useState } from "react";
import { EmptyState, VerticalPosterCard } from "@bloom/ui";
import { useLocale } from "../locale/locale-context.tsx";
import { useAuth } from "../auth/auth-context.tsx";
import { api } from "../api/client.ts";

interface MyListEntry {
  seriesId: string;
  slug: string;
  titleTh: string;
  titleEn: string;
  posterUrl: string;
}

export function MyListPage() {
  const { locale, t } = useLocale();
  const { user } = useAuth();
  const [items, setItems] = useState<MyListEntry[]>([]);

  useEffect(() => {
    if (!user) return;
    void api.get<{ items: MyListEntry[] }>("/api/me/my-list").then((d) => setItems(d.items));
  }, [user]);

  if (!user) {
    return (
      <div className="p-6 text-center">
        <p>{t("errors.unauthorized")}</p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-6xl space-y-6 px-4 py-8 sm:px-6">
      <h1 className="font-display text-3xl">{t("nav.my_list")}</h1>
      {items.length === 0 ? (
        <EmptyState title={t("errors.not_found")} />
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-6">
          {items.map((s) => (
            <VerticalPosterCard
              key={s.seriesId}
              href={`/series/${s.slug}`}
              titleTh={s.titleTh}
              titleEn={s.titleEn}
              posterUrl={s.posterUrl}
              locale={locale}
            />
          ))}
        </div>
      )}
    </div>
  );
}
